// 放弃理由
export const REJECT_REASON = {
    1: '地址信息不全',
    2: '商品库存不足',
    3: '其它'
}

// 拒绝退款原因
export const REFUSE_REASON = {
    1: '产品不支持退款',
    2: '其它'
}

// 订单状态
export const ORDER_STATE_LIST = [
    {
        name: '全部',
        value: -1
    },
    {
        name: '待发货',
        value: 1
    },
    {
        name: '已发货',
        value: 2
    },
    {
        name: '发货失败',
        value: 3
    },
    {
        name: '已签收',
        value: 4
    },
    {
        name: '申请退款',
        value: 5
    },
    {
        name: '退款成功',
        value: 6
    }
]


// WEBPACK FOOTER //
// ./src/views/wenchuang/constant.js